import { render, staticRenderFns } from "./DeviceData.vue?vue&type=template&id=d520262c"
import script from "./DeviceData.vue?vue&type=script&lang=js"
export * from "./DeviceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports